import styles from "./Donate.module.css";

export default function HeroSection() {
  return (
    <div className={styles.heroSection}>
      <h1 className={styles.heroTitle}>Support Our Mission</h1>
      <p className={styles.heroDescription}>
        Your generous donation helps us provide vital support, training, and
        resources to Mississippi’s hardworking roadworkers and their families
      </p>
    </div>
  );
}
